import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, TextField, Paper, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const CompleteRegistration = () => {
    const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get('code');

    const [formData, setFormData] = useState({
        password: '',
        confirmPassword: ''
    });
    const [error, setError] = useState('');
    const [dialogOpen, setDialogOpen] = useState(false);
    const [passwordValid, setPasswordValid] = useState({
        length: false,
        digit: false,
        special: false,
        uppercase: false,
    });

    // Walidacja hasła – aktualizacja warunków przy każdej zmianie hasła
    useEffect(() => {
        const validations = {
            length: formData.password.length >= 6,
            digit: /\d/.test(formData.password),
            special: /[!@#$%^&*(),.?":{}|<>]/.test(formData.password),
            uppercase: /[A-Z]/.test(formData.password),
        };
        setPasswordValid(validations);
    }, [formData.password]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.password !== formData.confirmPassword) {
            setError('Hasła muszą być takie same!');
            return;
        }
        // Sprawdzenie, czy wszystkie warunki hasła są spełnione
        if (!passwordValid.length || !passwordValid.digit || !passwordValid.special || !passwordValid.uppercase) {
            setError('Hasło nie spełnia wymagań!');
            return;
        }
        try {
            const payload = { code: code, password: formData.password };
            const response = await axios.post(`${baseUrl}/api/auth/completeRegisterRestaurant`, payload);
            if (response.status === 200) {
                setDialogOpen(true);
            }
        } catch (err) {
            setError('Wystąpił błąd podczas rejestracji.');
        }
    };

    return (
        <Box>
            <Paper sx={{ p: 2, maxWidth: 400, margin: 'auto', mt: 5 }}>
                <Typography variant="h5" sx={{ mb: 2 }}>
                    Dokończ rejestrację
                </Typography>
                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Hasło"
                        name="password"
                        type="password"
                        value={formData.password}
                        onChange={handleChange}
                        fullWidth
                        sx={{ mb: 2 }}
                    />
                    {/* Okienko z walidacją hasła */}
                    <Box sx={{ mb: 2, p: 1, border: '1px solid #ccc', borderRadius: '4px' }}>
                        <Typography variant="subtitle1">Wymagania dotyczące hasła:</Typography>
                        <Typography variant="body2" color={passwordValid.length ? "green" : "red"}>
                            {passwordValid.length ? <CheckCircleIcon fontSize="small" /> : <CancelIcon fontSize="small" />}
                            Co najmniej 6 znaków
                        </Typography>
                        <Typography variant="body2" color={passwordValid.digit ? "green" : "red"}>
                            {passwordValid.digit ? <CheckCircleIcon fontSize="small" /> : <CancelIcon fontSize="small" />}
                            Przynajmniej jedna cyfra
                        </Typography>
                        <Typography variant="body2" color={passwordValid.special ? "green" : "red"}>
                            {passwordValid.special ? <CheckCircleIcon fontSize="small" /> : <CancelIcon fontSize="small" />}
                            Przynajmniej jeden znak specjalny
                        </Typography>
                        <Typography variant="body2" color={passwordValid.uppercase ? "green" : "red"}>
                            {passwordValid.uppercase ? <CheckCircleIcon fontSize="small" /> : <CancelIcon fontSize="small" />}
                            Przynajmniej jedna duża litera
                        </Typography>
                    </Box>
                    <TextField
                        label="Potwierdź hasło"
                        name="confirmPassword"
                        type="password"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        fullWidth
                        sx={{ mb: 2 }}
                    />
                    {error && (
                        <Typography color="error" sx={{ mb: 2 }}>
                            {error}
                        </Typography>
                    )}
                    <Button type="submit" variant="contained" fullWidth>
                        Dokończ rejestrację
                    </Button>
                </form>
            </Paper>
            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                <DialogTitle>Rejestracja zakończona</DialogTitle>
                <DialogContent>
                    <Typography>
                        Rejestracja zakończona pomyślnie. Możesz zamknąć stronę.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)}>Zamknij</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default CompleteRegistration;